export interface LoanPurposeEntrepreneur {
  BUY_MORE_INVENTORIES: string;
  PAY_SHOP_OR_OUTLET_RENTAL: string;
  RENOVATE_SHOP_OR_OUTLET: string;
  EXPAND_OR_ADD_MORE_SHOP: string;
  PAY_BACK_LOANS: string;
  RECRUIT_MORE_EMPLOYEES: string;
}

export const /** @type {?} */ LOAN_PURPOSE_ENTREPRENEUR: LoanPurposeEntrepreneur = {
  BUY_MORE_INVENTORIES: 'Buy More Inventories',
  PAY_SHOP_OR_OUTLET_RENTAL: 'Pay Shop Or Outlet Rental',
  RENOVATE_SHOP_OR_OUTLET: 'Renovate Shop Or Outlet',
  EXPAND_OR_ADD_MORE_SHOP: 'Expand Or Add More Shop',
  PAY_BACK_LOANS: 'Pay Back Loans',
  RECRUIT_MORE_EMPLOYEES: 'Recruit More Employees',
};

export interface BusinessTypeEntrepreneur {
  FOOD: string;
  RETAIL_TRADING: string;
  CLOTHES_TRADING: string;
  SERVICES: string;
  OTHERS: string;
}

export const /** @type {?} */ BUSINESS_TYPE_ENTREPRENEUR: BusinessTypeEntrepreneur = {
  FOOD: 'Food',
  RETAIL_TRADING: 'Retail Trading',
  CLOTHES_TRADING: 'Clothes Trading',
  SERVICES: 'Services',
  OTHERS: 'Others',
};

export interface BusinessAgeEntrepreneur {
  LESS_THAN_ONE_YEAR: string;
  MORE_THAN_ONE_YEAR: string;
  MORE_THAN_THREE_YEARS: string;
  MORE_THAN_FIVE_YEARS: string;
  MORE_THAN_TEN_YEARS: string;
}

export const /** @type {?} */ BUSINESS_AGE_ENTREPRENEUR: BusinessAgeEntrepreneur = {
  LESS_THAN_ONE_YEAR: 'Less Than One Year',
  MORE_THAN_ONE_YEAR: 'More Than One Year',
  MORE_THAN_THREE_YEARS: 'More Than Three Years',
  MORE_THAN_FIVE_YEARS: 'More Than Five Years',
  MORE_THAN_TEN_YEARS: 'More Than Ten Years',
};

export interface BusinessPromotionEntrepreneur {
  MOSTLY_OFFLINE: string;
  MOSTLY_ONLINE: string;
  BOTH: string;
}

export const /** @type {?} */ BUSINESS_PROMOTION_ENTREPRENEUR: BusinessPromotionEntrepreneur = {
  MOSTLY_OFFLINE: 'Mostly Offline',
  MOSTLY_ONLINE: 'Mostly Online',
  BOTH: 'Both',
};

export interface OnlineChannelEntrepreneur {
  TOKOPEDIA: string;
  LAZADA: string;
  SHOPEE: string;
  BUKALAPAK: string;
  INSTAGRAM: string;
  OWN_WEBSITE: string;
  OTHER: string;
}

export const /** @type {?} */ ONLINE_CHANNEL_ENTREPRENEUR: OnlineChannelEntrepreneur = {
  TOKOPEDIA: 'Tokopedia',
  LAZADA: 'Lazada',
  SHOPEE: 'Shopee',
  BUKALAPAK: 'Bukalapak',
  INSTAGRAM: 'Instagram',
  OWN_WEBSITE: 'Own Website',
  OTHER: 'Other',
};

export interface BusinessPlaceEntrepreneur {
  OWN_HOUSE: string;
  RENT_RUKO: string;
  OWN_RUKO: string;
}

export const /** @type {?} */ BUSINESS_PLACE_ENTREPRENEUR: BusinessPlaceEntrepreneur = {
  OWN_HOUSE: 'Own House',
  RENT_RUKO: 'Rent Ruko',
  OWN_RUKO: 'Own Ruko',
};

export interface NumberOfEmployeesEntrepreneur {
  RUN_BY_MYSELF: string;
  HELPED_BY_FAMILY_MEMBERS: string;
  ONE_TO_FIVE_PEOPLE: string;
  FIVE_TO_TEN_PEOPLE: string;
  MORE_THAN_TEN_PEOPLE: string;
}

export const /** @type {?} */ NUMBER_OF_EMPLOYEES_ENTREPRENEUR: NumberOfEmployeesEntrepreneur = {
  RUN_BY_MYSELF: 'Run By Myself',
  HELPED_BY_FAMILY_MEMBERS: 'Helped By Family Members',
  ONE_TO_FIVE_PEOPLE: 'One To Five People',
  FIVE_TO_TEN_PEOPLE: 'Five To Ten People',
  MORE_THAN_TEN_PEOPLE: 'More Than Ten People',
};

export interface HelpedByFamilyMembers {
  ONE_TO_THREE: string;
  FOUR_TO_FIVE: string;
  MORE_THAN_FIVE: string;
}

export const /** @type {?} */ HELPED_BY_FAMILY_MEMBERS: HelpedByFamilyMembers = {
  ONE_TO_THREE: 'One To Three',
  FOUR_TO_FIVE: 'Four To Five',
  MORE_THAN_FIVE: 'More Than Five',
};
